var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert, CircularProgress, InputAdornment, IconButton, } from '@mui/material';
import { Visibility, VisibilityOff, AccountCircle, Lock, } from '@mui/icons-material';
import { useAuth } from '@/contexts/AuthContext';
var Login = function () {
    var _a = useState(''), username = _a[0], setUsername = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), showPassword = _c[0], setShowPassword = _c[1];
    var _d = useState(''), error = _d[0], setError = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var login = useAuth().login;
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!username.trim() || !password.trim()) {
                        setError('Please enter both username and password');
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    setError('');
                    return [4 /*yield*/, login(username, password)];
                case 1:
                    result = _a.sent();
                    if (!result.success) {
                        setError(result.error || 'Login failed');
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var togglePasswordVisibility = function () {
        setShowPassword(!showPassword);
    };
    return (_jsx(Box, { sx: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: 2,
        }, children: _jsx(Card, { sx: {
                maxWidth: 400,
                width: '100%',
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            }, children: _jsxs(CardContent, { sx: { p: 4 }, children: [_jsxs(Box, { sx: { textAlign: 'center', mb: 3 }, children: [_jsx(Typography, { variant: "h4", component: "h1", sx: { fontWeight: 'bold', mb: 1 }, children: "Channel Manager" }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: "Inicia sesi\u00F3n para continuar" })] }), error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: error })), _jsxs("form", { onSubmit: handleSubmit, children: [_jsx(TextField, { fullWidth: true, label: "Usuario", value: username, onChange: function (e) { return setUsername(e.target.value); }, margin: "normal", variant: "outlined", disabled: isLoading, InputProps: {
                                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(AccountCircle, { color: "action" }) })),
                                }, sx: { mb: 2 } }), _jsx(TextField, { fullWidth: true, label: "Contrase\u00F1a", type: showPassword ? 'text' : 'password', value: password, onChange: function (e) { return setPassword(e.target.value); }, margin: "normal", variant: "outlined", disabled: isLoading, InputProps: {
                                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Lock, { color: "action" }) })),
                                    endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { "aria-label": "toggle password visibility", onClick: togglePasswordVisibility, edge: "end", disabled: isLoading, children: showPassword ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}) }) })),
                                }, sx: { mb: 3 } }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", size: "large", disabled: isLoading, sx: {
                                    py: 1.5,
                                    fontWeight: 'bold',
                                    background: 'linear-gradient(45deg, #0ea5e9, #3b82f6)',
                                    '&:hover': {
                                        background: 'linear-gradient(45deg, #0284c7, #2563eb)',
                                    },
                                }, children: isLoading ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : ('Iniciar Sesión') })] }), _jsx(Box, { sx: { mt: 3, textAlign: 'center' }, children: _jsx(Typography, { variant: "body2", color: "text.secondary", children: "\u00BFNecesitas ayuda? Contacta al administrador" }) })] }) }) }));
};
export default Login;
